import { menuGridGeneratorModule } from '@menuGridGenerator/module';
import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { state } from './models';
import { menuEditorModule } from './views/MenuEditor/module';

export const menuModule = {
  state,
  getters,
  actions,
  mutations,
  modules: {
    menuEditor: menuEditorModule,
    menuGridGenerator: menuGridGeneratorModule
  }
};
